module.exports = {
  /* 测试号 */
  // appid: "wx480060fd7fc150bb",
  // loginUrl: "http://192.168.3.217:8081/#/login", //登录页

  /* 线上 */
  appid: "wxadab8f613a96dfef",
  loginUrl: "https://h5.shzskx.cn/#/login", //登录页
};